import { useState } from "react";
import { Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, imgUrl } from "@/lib/api";

export const ImageUpload = ({ value, onChange, testid, square = false }) => {
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url);
      toast.success("Gambar diunggah");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div className="flex items-center gap-4">
      <div className={`${square ? "w-24 h-24" : "w-28 h-20"} rounded-lg overflow-hidden bg-sage-100 border border-sage-200 shrink-0`}>
        {value && <img src={imgUrl(value)} alt="" className={`w-full h-full ${square ? "object-contain bg-white" : "object-cover"}`} />}
      </div>
      <label className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-sage-200 bg-paper cursor-pointer hover:bg-sage-100 text-sm">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Unggah gambar
        <input type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={onFile} data-testid={testid} />
      </label>
    </div>
  );
};
